export { default as stateToMarkdown } from './stateToMarkdown';


//////////////////
// WEBPACK FOOTER
// ../draft-js-export-markdown/esm/main.js
// module id = 2059
// module chunks = 22